// extracted by mini-css-extract-plugin
export var option = "_5a-1";
export var optionActive = "_5a-2";
export var pill = "_5a-0";